module.exports = __webpack_public_path__ + "static/img/iconfont.df96f12.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon_custom/iconfont.svg?t=1566030762759
// module id = 459
// module chunks = 99